import { IconList, IconListItem, Text, Title } from '@folio/components';
import { CustomIncludedPerilsProps } from 'korint-sdk';
import { CheckIcon } from 'lucide-react';

export function IncludedPerilsProtectionJuridique({ tier }: CustomIncludedPerilsProps) {
  const essentialGuarantees = [
    {
      title: 'SANTE',
      details: ["L'atteinte à la personne"],
    },
    {
      title: 'IMMOBILIER',
      details: ['Votre habitation'],
    },
    {
      title: 'CONSOMMATION',
      details: ['Votre consommation', 'Vos loisirs', 'Vos activités collaboratives'],
    },
    {
      title: 'SERVICE',
      details: ['Vos relations avec les organismes bancaires, de crédit et les assurances'],
    },
    {
      title: 'SOCIAL',
      details: ['Votre travail'],
    },
    {
      title: 'ADMINISTRATION',
      details: ['Vos relations avec les services publics'],
    },
    {
      title: 'VEHICULES',
      details: [
        "La propriété et l'usage d'un véhicule terrestre à moteur",
        'La conduite responsable',
      ],
    },
  ];

  const summumGuarantees = [
    {
      title: 'SANTE',
      details: ["L'atteinte à la personne"],
    },
    {
      title: 'IMMOBILIER',
      details: [
        'Votre habitation',
        'Vos constructions et travaux',
        'Vos transactions immobilières',
      ],
    },
    {
      title: 'CONSOMMATION',
      details: ['Votre consommation', 'Vos loisirs', 'Vos activités collaboratives'],
    },
    {
      title: 'SERVICE',
      details: ['Vos relations avec les organismes bancaires, de crédit et les assurances'],
    },
    {
      title: 'SOCIAL',
      details: ['Votre travail'],
    },
    {
      title: 'ADMINISTRATION',
      details: ['Vos relations avec les services publics', 'Votre fiscalité'],
    },
    {
      title: 'PATRIMONIAL',
      details: ['Votre patrimoine immobilier'],
    },
    {
      title: 'VEHICULES',
      details: [
        "La propriété et l'usage d'un véhicule terrestre à moteur",
        'La conduite responsable',
      ],
    },
    {
      title: 'FAMILLE',
      details: [
        'Le changement de régime matrimonial',
        'Le divorce, la séparation et la rupture de la vie commune',
        "La filiation, l'adoption",
        'Les donations, legs et libéralités',
        'Les successions',
        'La dépendance',
        "Les mesures de protection d'un proche",
        'Les emplois familiaux',
        'Le droit de visite des grands-parents',
      ],
    },
  ];

  return (
    <IconList icon={<CheckIcon className="size-5 text-green-600" />} className="text-sm">
      {(tier === 'SUMMUM' ? summumGuarantees : essentialGuarantees).map(guarantee => (
        <IconListItem key={guarantee.title}>
          <Title order={4}>{guarantee.title}</Title>
          {guarantee.details.map((detail, index) => (
            <Text key={`basic-${guarantee.title}-${index}`} className="leading-relaxed">
              • {detail}
            </Text>
          ))}
        </IconListItem>
      ))}
    </IconList>
  );
}
